<template>
<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-GeRenXiYingXuanZhong`]" width="1em" height="1em" v-bind="$attrs"><path d="M2.46094 5.92578V9.26967C2.46094 11.9686 4.9406 14.1566 7.9994 14.1566C11.0582 14.1566 13.5379 11.9686 13.5379 9.26967V5.92578" stroke="#000" stroke-width="1.231" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.46094 1.84766V4.07843M13.5379 4.07843V1.84766" stroke="#8C6FFF" stroke-width="1.231" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconGeRenXiYingXuanZhong',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
